module.exports = __webpack_public_path__ + "img/logo3.2852e867.png";